import Vue from 'vue'
import { clone } from '@/js/utils'
import { generate_card } from '@/js/game-utils'



// === STATE =====================================================================================
const default_state = {
	status: 'starting',
	deck: [],
	wins: [],
	score: 0
}

const state = clone(default_state)




// === GETTERS =====================================================================================
const getters = {
	game(state) { return state },
	level(state) {
		const wins = state.wins.length + 1
		return Math.ceil(wins/2)
	},
	score(state) {
		return state.wins.reduce((a, v) => a += v.score, 0)
	}
}




// === ACTIONS =====================================================================================
const actions = {

	init_game({ commit, dispatch }, data) {
		commit('EDIT_GAME_STATE', { ...clone(default_state) })

		dispatch('init_deck')
		dispatch('init_fight')

		setTimeout(() => {
			commit('EDIT_GAME_STATE', { status: 'ready' })
		}, 3000)
	},

	init_deck({ commit }, data) {
		let deck = [
			generate_card({ level: 2 }),
			generate_card({ level: 2 }),
			generate_card({ level: 1 }),
			generate_card({ level: 1 }),
			generate_card({ level: 1 }),
			generate_card({ level: 1 }),
			// generate_card(), generate_card(), generate_card(), generate_card(),
			// generate_card(), generate_card(), generate_card(), generate_card(),
			// generate_card(), generate_card(), generate_card(), generate_card()
		]
		commit('EDIT_GAME_STATE', { deck })
	},

	select_reward({ state, commit }, data) {
		if (data.card && !state.deck.find((c) => c.id === data.card.id)) {
			commit('EDIT_GAME_STATE', { deck: [ data.card, ...state.deck ] })
		}
	},


}



// === MUTATIONS =====================================================================================
const mutations = {

	EDIT_GAME_STATE(state, data) {
		for (let i in data) {
			Vue.set(state, i, data[i])
		}
	},

}

export default { state, getters, actions, mutations }
